// @ts-nocheck
import React from 'react';
import styled, { css } from 'styled-components';
import { Option, Select } from '../ant/Select';
export const yesNoValue = {
  yes: true,
  no: false
};
const yesNo = {
  yes: 'Да',
  no: 'Нет'
};
const StyledSelect = styled(Select).withConfig({
  displayName: "YesNoSelect__StyledSelect",
  componentId: "sc-alqicz-0"
})(["", ";"], props => css(["max-width:", ";"], props.fullWidth ? '100%' : '88px'));
export default ({
  value,
  reset,
  optionText,
  ...props
}) => {
  const {
    placeholder
  } = props;
  const valueSelect = value ? yesNo.yes : value === false ? yesNo.no : placeholder === undefined ? yesNo.no : undefined;
  return <StyledSelect allowClear placeholder={placeholder ? placeholder : 'Нет'} {...props} value={valueSelect} onChange={value => {
    if (reset === true) {
      props.onChange && props.onChange(value ? value === yesNo.yes : undefined);
    } else {
      props.onChange && props.onChange(value === yesNo.yes);
    }
  }}>
      {Object.keys(yesNo).map(key => <Option value={yesNo[key]} key={key}>
          {optionText ? `${optionText} (${yesNo[key]})` : yesNo[key]}
        </Option>)}
    </StyledSelect>;
};
